import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";
import { cardHeaderStyles, cardContentStyles } from "../../../theme/mixins";

export const CustomTermsWrapper = styled.div`
  margin-top: 20px;
`;

export const CustomTermsHeader = styled.div`
  ${cardHeaderStyles};
`;

export const CustomTermsContent = styled.div`
  ${cardContentStyles};
  flex-direction: column;
`;

export const CustomTermsLink = styled.a`
  font-weight: ${({ theme }) => theme.fontWeight.bolder};
  color: ${({ theme }) => theme.colors.primary};

  &:hover {
    color: ${({ theme }) => theme.colors.secondary};
  }

  &:focus {
    color: ${({ theme }) => theme.colors.primary};
  }

  ${mediaMaxWidth.tablet} {
    font-size: ${({ theme }) => theme.fontSize.normal.mobile};
  }
`;
